import { Editor } from "@tinymce/tinymce-react";
import Loader from "components/loader";
import { useFormik } from "formik";
import { useEffect, useMemo, useRef, useState } from "react";
import { toast } from "react-toastify";
import { renderError, renderImagePreview } from "utils/utils";
import * as yup from "yup";
import crossIcon from "../../../assets/svg/crossBtn.svg";
import { v4 as uuidv4 } from "uuid";
import uploadIcon from "../../../assets/svg/upload-icon.svg";
import {
  addSpecialMessage,
  getSpecialMessage,
  updateSpecialMessage,
} from "../../../axios/api";

const SpecialMessage = () => {
  const editorRef = useRef(null);

  const [FlData, setFlData] = useState<any>();
  const [specialFlData, setSpecialFlData] = useState<any>(false);
  const [loading, setLoading] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [editorContent, setEditorContent] = useState("");
  const styleForEditor =
    ':root { --background-color: #fff; --boxshadow-color: #00000030; } body { font-family: Poppins, sans-serif; } .dark { --background-color: #1F2937; --boxshadow-color: #BDBDBD75; color: #fff; } details > summary::-webkit-details-marker { display: none; } summary { background-color: var(--background-color); padding: 10px; cursor: pointer; margin-right: 0.5rem; } details summary { list-style: none; cursor: pointer; position: relative; } details p { padding: 0.5rem; } details summary::marker { display: none; } details summary::before { content: "▼"; display: inline-block; width: 1em; height: 1em; position: absolute; top: 20%; right: 5%; transition: all 0.3s ease; } details[open] summary::before { transform: rotate(180deg); top: 40%; } details { width: 92%; margin-left: calc(4% - 6px); box-shadow: 0 0 10px var(--boxshadow-color); padding: 5px; background-color: var(--background-color); cursor: pointer; margin-bottom: 15px; }';
  const fileInputRef = useRef(null);

  const formik = useFormik({
    initialValues: {
      description: "",
      image: null,
      ImageUrl: "",
      special_fl_msg: false,
    },
    onSubmit: async (values) => {
      if (formik.values.special_fl_msg) {
        if (!values.description && !values.image && !values.ImageUrl) {
          toast.error("Please add at least an image or description");
          return;
        }
      }
      try {
        setLoading(true);
        // console.log("values", values);
        const formData = new FormData();

        const fullContent = `<html><head><link rel="preconnect" href="https://fonts.googleapis.com"><link rel="preconnect" href="https://fonts.gstatic.com" crossorigin><link href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap" rel="stylesheet"><meta name="viewport" content="width=device-width, initial-scale=1.0"><meta http-equiv="Content-Security-Policy" content="default-src *; img-src * 'self' data:; script-src 'unsafe-inline' 'unsafe-eval' *; style-src 'unsafe-inline' *;"><style>${styleForEditor}</style></head><body>${editorContent}</body></html>`;
        formData.append("locale", "1");
        if (editorContent) {
          formData.append("description", fullContent);
        } else {
          formData.append("description", "");
        }
        if (!FlData) {
          formData.append("financial_message_id", uuidv4());
        } else {
          formData.append("financial_message_id", FlData?.financial_message_id);
        }
        if (FlData?.id) {
          formData.append("id", FlData?.id);
        }
        formData.append(
          "image",
          (values?.image && values.image) ||
            (values?.ImageUrl &&
              values.ImageUrl.replace(
                /(https?:\/\/)?(?:\d{1,3}\.){3}\d{1,3}/,
                ""
              )) ||
            ""
        );
        formData.append("special_fl_msg", String(values.special_fl_msg));
        // console.log("Form Data:", formData);
        let responseData: any;
        if (FlData) {
          responseData = await updateSpecialMessage(formData);
          if (responseData?.data?.success) {
            toast.success("Special Message Updated Sucessfully");
          } else {
            toast.error(responseData?.data?.message);
          }
        } else {
          responseData = await addSpecialMessage(formData);
          if (responseData?.data?.success) {
            toast.success("Special Message Added Sucessfully");
          } else {
            toast.error(responseData?.data?.message);
          }
        }
        // console.log("API Response:", responseData);
      } catch (error: any) {
        if ((error.response.data.message = "File too large")) {
          toast.error("Image size should be less then 100kb");
        } else {
          toast.error("Something Went Wrong" + error.message);
        }
      } finally {
        setLoading(false);
        fetchSpecialMessage();
      }
    },
    validationSchema: yup.object({}),
  });
  // console.log("formik.values", formik.values);
  const checkImage = useMemo(
    () => renderImagePreview(formik.values.image, formik.values.ImageUrl),
    [formik.values.image, formik.values.ImageUrl]
  );

  // Trigger fileInput on click on div
  const handleDivClick = (ref: any) => {
    ref.current.click();
  };

  const handleDragOver = (e: any) => {
    e.preventDefault();
  };

  const handleDrop = (e: any, fieldName: any) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file.size > 100 * 1024) {
      setPopupMessage("Image size should be less than 100kb.");
      formik.setFieldValue(fieldName, null);
    } else {
      setPopupMessage("");
      formik.setFieldValue(fieldName, file);
    }
  };

  const handleEditorChange = (content: any, editor: any) => {
    setEditorContent(content);
    formik.setFieldValue("description", content);
  };

  const fetchSpecialMessage = async () => {
    try {
      setLoading(true);
      const flMessageResp = await getSpecialMessage();
      setSpecialFlData(flMessageResp?.data?.data?.special_fl_msg);
      setFlData(flMessageResp?.data?.data?.spl_fl_message[0]);
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchSpecialMessage();
  }, []);

  useEffect(() => {
    if (FlData) {
      formik.setValues({
        description: FlData.description,
        image: null,
        ImageUrl: FlData.image,
        special_fl_msg: specialFlData,
      });
      setEditorContent(FlData.description);
    }
  }, [FlData]);
  return (
    <div className="m-3 bg-[#FFFFFF] p-3">
      {loading ? (
        <Loader />
      ) : (
        <form onSubmit={formik.handleSubmit}>
          <div className="my-5 flex w-11/12 flex-col">
            <div className="flex items-center gap-4">
              <label htmlFor="special_fl_msg" className="text-xl font-normal">
                Display Special Message
              </label>
              <input
                type="checkbox"
                className="h-6 w-6 accent-[#0098DA]"
                name="special_fl_msg"
                id="special_fl_msg"
                checked={formik.values.special_fl_msg}
                onChange={(e) =>
                  formik.setFieldValue("special_fl_msg", e.target.checked)
                }
                onBlur={formik.handleBlur}
              />
            </div>
            {formik.values.special_fl_msg && (
              <>
                <div className="my-5  gap-5">
                  <div className="w-[35%]">
                    <div className="mb-1 flex flex-col">
                      <label
                        htmlFor="ImageUrl"
                        className=" text-xl font-medium"
                      >
                        Image{" "}
                      </label>
                      <span className=" text-sm text-red-500">
                        (Image resolution should be 350*150)
                      </span>
                      <span className=" text-sm text-red-500">
                        (Valid Image Formats: jpg, jpeg, png and gif)
                      </span>
                    </div>
                    <div className="relative my-3 mb-5 flex w-[100%] items-center justify-between">
                      <input
                        // className="absolute bottom-0 left-8 -z-10 w-20"
                        className="absolute inset-0 h-full w-full cursor-pointer opacity-0"
                        // required={!formik.values.ImageUrl && !formik.values.image}
                        name="ImageUrl"
                        id="ImageUrl"
                        ref={fileInputRef}
                        type="file"
                        accept=".jpg, .jpeg, .png, .gif"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file?.size > 100 * 1024) {
                            setPopupMessage(
                              "Image size should be less than 100kb."
                            );
                            formik.setFieldValue("BannerImageUrl", "");
                          } else {
                            setPopupMessage("");
                            formik.setFieldValue("ImageUrl", file?.name);
                            formik.setFieldValue("image", file);
                          }
                        }}
                      />
                      <div
                        onDragOver={handleDragOver}
                        onDrop={(e) => handleDrop(e, "image")}
                        onClick={() => handleDivClick(fileInputRef)}
                        className="relative flex h-44 w-full items-center justify-center overflow-hidden rounded border-4 border-dashed"
                      >
                        {formik.values.ImageUrl || formik.values.image ? (
                          <>
                            <div className="relative flex items-center p-2">
                              {(formik.values.image ||
                                formik.values.ImageUrl) && (
                                <img
                                  className="object-scale-down"
                                  alt="banner-img"
                                  src={checkImage}
                                />
                              )}
                            </div>
                            <button
                              type="button"
                              onClick={(e) => {
                                e.stopPropagation(); // Stop event propagation
                                formik.setFieldValue("image", null);
                                formik.setFieldValue("ImageUrl", "");
                                fileInputRef.current.value = null;
                              }}
                              className="absolute right-1 top-1 z-10"
                            >
                              <img src={crossIcon} alt="Cross Icon" />
                            </button>
                          </>
                        ) : (
                          <div
                            id="imageDiv"
                            className="flex flex-col items-center justify-center text-center font-medium hover:cursor-pointer"
                          >
                            <img
                              className="mb-2 w-1/4"
                              src={uploadIcon}
                              alt="Upload Icon"
                            />
                            <span>
                              <span className="text-blue-500">Click here </span>
                              to Upload
                            </span>
                            <span> Banner Image</span>
                          </div>
                        )}
                      </div>
                    </div>
                    {popupMessage && (
                      <div className="top-full text-center text-red-500">
                        {popupMessage}
                      </div>
                    )}
                  </div>
                </div>
                <div className="my-5">
                  <label htmlFor="" className="my-2 text-xl font-medium">
                    FL Message
                  </label>
                  <div className="my-3">
                    <Editor
                      onEditorChange={handleEditorChange}
                      tinymceScriptSrc="/tinymce/tinymce.min.js"
                      licenseKey="gpl"
                      onInit={(_evt, editor) => (editorRef.current = editor)}
                      value={editorContent}
                      init={{
                        relative_urls: false,
                        remove_script_host: false,
                        convert_urls: true,
                        height: 500,
                        menubar: false,
                        plugins: [
                          "advlist",
                          "autolink",
                          "lists",
                          "link",
                          "preview",
                          "anchor",
                          "visualblocks",
                          "code",
                          "fullscreen",
                          "insertdatetime",
                          "media",
                          "help",
                          "wordcount",
                          "accordion",
                          "preview",
                          "emoticons",
                          "link", // Custom plugin should be correctly referenced
                        ],
                        toolbar: [
                          "undo redo | blocks blockquote | " +
                            "bold italic underline strikethrough superscript subscript | forecolor backcolor | " +
                            "align bullist numlist | outdent indent | " +
                            "emoticons | removeformat | preview | help", // Ensure toolbar buttons are added
                        ],
                        toolbar_sticky: true,
                        content_style: styleForEditor,
                        // setup: (editor) => {
                        //   editor.on("change", (e) => {
                        //     handleEditorChange(
                        //       editor.getContent({ format: "html" }),
                        //       editor
                        //     );
                        //   });
                        // },
                      }}
                    />
                  </div>
                  {formik.touched.description && formik.errors.description ? (
                    <div>{renderError(formik.errors.description)}</div>
                  ) : null}
                </div>
              </>
            )}
            <div>
              <button
                name="submit"
                className="float-right my-5 w-24 rounded bg-[#008BD2] p-2 text-xl font-bold text-white"
                type="submit"
              >
                Submit
              </button>
            </div>
          </div>
        </form>
      )}
    </div>
  );
};

export default SpecialMessage;
